import React from 'react';
import Finished from "../common/Finished";

const BeneficiaryFinished = () => {
    return (
        <Finished headerText="Thank you!"
                  submissionText="Thank you for completing the beneficiary portion of the claim. We'll contact you if additional information is needed."
        />
    )
};
export default BeneficiaryFinished;